import React from 'react';

interface ErrorContext {
  setShowAlert: (isError: boolean) => void;
}

export default React.createContext<ErrorContext>({} as ErrorContext);
